<template>
    <div>
        <div class="d-flex">
            <div class="p-2">Views</div>

            <div class="d-flex align-items-center">
                <a href="javascript:void(0)" @click="addView" class="badge text-bg-primary mx-1">new view</a>
            </div>

        </div>

        <table class="table table-sm">
            <thead>
            <tr>
                <th scope="col">Name</th>
                <th scope="col">Layout</th>
                <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="view in table.views">
                <td>
                    <router-link :to="{ name: 'view-renderer', params: {id: view.id}}">
                        {{view.name}}
                    </router-link>
                </td>

                <td>
                    {{view.view_type}}
                </td>

                <td>

                    <a href="javascript:void(0)" @click="onEditClick(view)">
                        <i class="fas fa-edit"></i>
                    </a>

                    <a href="javascript:void(0)" @click="onDeleteViewClick(view.id)">
                        <i class="fas fa-trash-alt"></i>
                    </a>

                    <router-link :to="{ name: 'view-editor', params: {id: view.id}}">
                        <i class="fas fa-cog"></i>
                    </router-link>

                    <router-link :to="{ name: 'view-renderer', params: {id: view.id}}">
                        <i class="fas fa-external-link-alt"></i>
                    </router-link>

                </td>
            </tr>

            </tbody>
        </table>

        <view-modal :key="'view-on-' + table.id" v-if="showViewEditor" :table="table"
                     :view="currentView" @noEvent="showViewEditor = false"></view-modal>

        <confirm-modal :key="'confirm-modal-on-' + table.id"
                       v-if="showConfirmModal"
                       @noEvent="showConfirmModal = false"
                       :yesEvent="deleteView"
                       text="Are you sure you want to delete this view?">
        </confirm-modal>

    </div>
</template>

<script>
    import ViewModal from "./ViewModal.vue";
    import ViewService from "../../services/ViewService";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ArrayUtil from "../../utils/ArrayUtil";

    export default {
        name: 'ViewList',
        components: {ConfirmModal, ViewModal},
        props: ['table'],
        data () {
            return {
                model: webase.model,
                arrayUtil: new ArrayUtil(),
                currentView: {
                    name: '',
                    view_type: 'list',
                    model_id: '',
                    published: false,
                    group_field_id: null,
                    id: null
                },
                showViewEditor: false,
                showConfirmModal: false,
                deleteView: function () {
                }
            }
        },
        mounted () {
        },
        methods: {
            addView() {
                this.currentView = {
                    name: '',
                    view_type: 'list',
                    model_id: this.table.id,
                    published: false,
                    group_field_id: null,
                    id: null
                }

                this.showViewEditor = true
            },
            onDeleteViewClick(viewId) {
                let viewService = new ViewService()
                this.showConfirmModal = true

                this.deleteView = () => {
                    viewService.remove(viewId).then(() => {
                        this.arrayUtil.remove(this.table.views, viewId)
                        this.showConfirmModal = false
                    }).catch((error) => {
                        console.log('Error removing view.')
                        console.log(error)
                        this.showConfirmModal = false
                    })
                }
            },
            onEditClick(view) {
                this.currentView = view
                this.showViewEditor = true
            }
        }
    }
</script>

<style>

</style>
